import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

interface Props {
  text: string;
}
const limit = 0;

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseInformationSection',
  props: {
    text: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const isExpanded = ref<boolean>(false);
const toggleShow = (): void => {
  isExpanded.value = !isExpanded.value;
};

const displayText = computed<string>(() => {
  if (isExpanded.value) {
    return props.text;
  }
  const words = props.text.split(" ");
  let truncatedText = "";
  for (const word of words) {
    if ((truncatedText + word).length > limit) {
      break;
    }
    truncatedText += (truncatedText ? " " : "") + word;
  }
  return truncatedText;
});

const __returned__ = { props, isExpanded, toggleShow, limit, displayText, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})